import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { CLPrescriptionColumnContainer } from '../CLPrescriptionColumn/CLPrescriptionColumnContainer.js';

const CLTwoColPrescriptionSelector = ({ prescriptionAttributesSet  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("div", {
        className: "cl-two-col-prescription-selector",
        "data-t": "contact-lens-configurator"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "cl-two-col-prescription-selector__grid"
    }, /*#__PURE__*/ React.createElement(CLPrescriptionColumnContainer, {
        eyeSideId: "right",
        "data-t": "prescription-right-eye",
        parameters: prescriptionAttributesSet,
        className: "cl-two-col-prescription-selector__column cl-two-col-prescription-selector__column--right",
        columnTitle: getLabel(`products.contactLenses.rightEye`)
    }), /*#__PURE__*/ React.createElement(CLPrescriptionColumnContainer, {
        eyeSideId: "left",
        "data-t": "prescription-left-eye",
        parameters: prescriptionAttributesSet,
        className: "cl-two-col-prescription-selector__column cl-two-col-prescription-selector__column--left",
        columnTitle: getLabel(`products.contactLenses.leftEye`)
    })));
};

export { CLTwoColPrescriptionSelector };
//# sourceMappingURL=CLTwoColPrescriptionSelector.js.map
